import { packageTypeEnum, promotionTypeEnum, discountType } from "./enums/enum"
import moment from "moment";

export function calculatePackagePrice(packageId, packageType, promotion = null, discount = null) {

    let currentPackage = this.$store.state.subscriptions.offers.filter(x => x.id === packageId);
    if (!currentPackage || currentPackage.length === 0) {
        return 0;
    }

    currentPackage = currentPackage[0];
    let price = getPackagePrice(packageType, currentPackage)

    if (promotion && !discount) {
        if (promotion.promotion_type === promotionTypeEnum.ANNUAL && packageType === packageTypeEnum.ANNUAL) {
            price = calculateDiscount(promotion, price);
        } else if (promotion.promotion_type === promotionTypeEnum.SEASONAL && packageType === packageTypeEnum.SEASONAL) {
            price = calculateDiscount(promotion, price);
        } else if (promotion.promotion_type === promotionTypeEnum.ALL) {
            price = calculateDiscount(promotion, price);
        }
    }

    if(discount && !promotion) {
        price = calculateDiscount(discount, price);
    }

    return price;
}

export function calculateDiscount(discount, price) {
    if(discount) {
        if(discount.type === discountType.PERCENTAGE) {
            price -= (discount.discount / 100) * price
        }
        else if(discount.type === discountType.AMOUNT) {
            price -= discount.discount
        }
    }
    return parseFloat(price.toFixed(2));
}

function getPackagePrice(packageType, currentPackage) {
    if(packageType === packageTypeEnum.ANNUAL) {
        return currentPackage.annual_price
    } else if(packageType === packageTypeEnum.SEASONAL) {
        return currentPackage.seasonal_price
    }
    return 0;
}

export function transformDistance(distance){
    if(distance > 1000){
      return (distance / 1000).toFixed(2) + ' km';
    }
    return distance + ' m';
}

export function formatDate(date) {
    return moment(date).format('DD.MM.YYYY');
}